const planetCarousel = document.querySelector(".js-planets"),
    planetSlides = document.querySelectorAll(".js-planet"),
    planetTitles = document.querySelector(".js-planet-titles"),
    firstVideo = document.querySelector(".js-first-video"),
    bgImgs = document.querySelectorAll(".js-bg-imgs"),
    soundBtn = document.querySelector(".js-sound-btn");

    let audioPlaying = false,
        audioFirstClick = true,
        planets = [],
        planetCount = 0,
        currentIndex = 0;

    bgImgs.forEach((image) => {

        if (screenOrientation == "landscape") {
            image.src = image.dataset.srclandscape;
        } else {
            image.src = image.dataset.srcportrait;
        }

        imagesLoaded( image, function( ) { 
            image.classList.add("lazy-loaded");
            image.removeAttribute('data-srclandscape');
            image.removeAttribute('data-srcportrait');
        });

    });

// load first videoo
if (typeof firstVideo != "undefined" && firstVideo != null) {
    let videoSource = firstVideo.getElementsByTagName("source")[0];
    if (screenOrientation == "landscape") {
        videoSource.src = videoSource.dataset.srclandscape;
    } else {
        videoSource.src = videoSource.dataset.srcportrait;
    }

    firstVideo.load();
    videoSource.removeAttribute("data-srclandscape");
    videoSource.removeAttribute("data-srcportrait");
}

// set up main carousel
if (typeof planetCarousel != "undefined" && planetCarousel != null) {
    let planetOptions = {
        cellAlign: "center",
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        setGallerySize: false,
        resize: true,
        groupCells: 1,
        cellSelector: ".planet-carousel__planet"
    };

    const planetFlkty = new Flickity(planetCarousel, planetOptions);

    const prevButton = planetCarousel.querySelector(".js-planets-prev"),
        nextButton = planetCarousel.querySelector(".js-planets-next");

    prevButton.addEventListener("click", () => {
        planetFlkty.previous();
    });

    nextButton.addEventListener("click", () => {
        planetFlkty.next();
    });

    // lazy load next video and swap audio
    planetFlkty.on("change", function (index) {
        const selectedPlanet = planetSlides[index],
            selectedPlanetLazyVideo = selectedPlanet.querySelector(".js-lazy-video");    
                
        currentIndex = index;

        if (
            typeof selectedPlanetLazyVideo != "undefined" &&
            selectedPlanetLazyVideo != null
        ) {
            let videoSource =
                selectedPlanetLazyVideo.getElementsByTagName("source")[0];
            if (screenOrientation == "landscape") {
                videoSource.src = videoSource.dataset.srclandscape;
            } else {
                videoSource.src = videoSource.dataset.srcportrait;
            }

            selectedPlanetLazyVideo.load();
            selectedPlanetLazyVideo.play();
            videoSource.removeAttribute("data-srclandscape");
            videoSource.removeAttribute("data-srcportrait");
            selectedPlanetLazyVideo.classList.remove("js-lazy-video");
        }

        if (!audioFirstClick) {
            swapAudio(currentIndex);
        }
    });

    planetFlkty.on( 'dragStart', function() {
        dragging = true;
    });

    planetFlkty.on( 'pointerUp', function() {
        setTimeout(function(){ 
            dragging = false;
         }, 300);
    });
    
    // if slide is clicked (not draggde) update sound state
    planetSlides.forEach((slide) => {
        slide.addEventListener("click", () => {
            if (!dragging) {
                updateButtonState();
            }
        });
    });

}

// set up title carousel
if ((typeof planetTitles != "undefined") && (planetTitles != null)) {

    let titleOptions = {
        cellAlign: "center",
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        setGallerySize: false,
        resize: true,
        groupCells: 1,
        cellSelector: ".title-carousel__slide",
        asNavFor: ".js-planets",
        draggable: false
    };

    const titleFlkty = new Flickity(planetTitles, titleOptions);

}

// sound btn click
soundBtn.addEventListener("click", (e) => {
    e.preventDefault();

    // on first click initialise the audio players (must be started by user interaction)
    if (audioFirstClick) {
        audioFirstClick = false;

        planetSlides.forEach((slide) => {
            let planetAudioFile = slide.dataset.audio;
            planets.push(
                new planetAudio(
                        planetCount, 
                        planetAudioFile
                    )
            );
            planetCount++;
        });

        swapAudio(currentIndex);
    
    }
   
    updateButtonState();

});

function updateButtonState() {
    audioPlaying = !audioPlaying;

    if (audioPlaying) {
        soundBtn.innerHTML = 'Sound Off';
        Howler.mute(false);
    } else {
        soundBtn.innerHTML = 'Sound On';
        Howler.mute(true);
    }
}

function planetAudio(planetId, planetAudioFile) {
    this.planetId = planetId;
    this.planetPlayer = new Howl({
        src: planetAudioFile,
        loop: true,
        mute: true,
        onplayerror: function () {
            this.planetAudio.once("unlock", function () {
                this.planetAudio.play();
            });
        },
        onload: function() {
            // console.log('loaded: ' + stationid);
        }
    });
    this.planetPlayer.play();
}

function swapAudio(currentIndex) {
    planets.forEach((planet) => {
        if (planet.planetId == currentIndex) {
            planet.planetPlayer.mute(false);
        } else {
            planet.planetPlayer.mute(true);
        }
    });
}
